package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_09_27_Day_1
import com.veldekar.components.logs.Log_2024_09_27_Day_2
import com.veldekar.components.logs.Log_2024_09_27_Day_3
import com.veldekar.components.logs.Log_2024_09_27_Day_4
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-09-27")
@Composable
public fun Log_2024_09_27(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Dinner with Elrovir",
        ogTitle = "Dinner with Elrovir",
        date = LocalDate(2_024, 9, 27),
        ogDescription = "The heroes meet Lady Aventary's husband, Elrovir Rodiridan, and prepare for a journey toward the Brij Bridge.",
        ogImage = "ai/2024-09-27.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-53", dateString = "Newgrowth 53")
        Log_2024_09_27_Day_1()
        SessionDayHeader(dayId = "newgrowth-55", dateString = "Newgrowth 55")
        Log_2024_09_27_Day_2()
        SessionDayHeader(dayId = "newgrowth-56", dateString = "Newgrowth 56")
        Log_2024_09_27_Day_3()
        SessionDayHeader(dayId = "newgrowth-57", dateString = "Newgrowth 57")
        Log_2024_09_27_Day_4()
        SessionMediaItem(
            image = "images/LadyAventary_ElrovirRodiridan_small.webp",
            linkImage = "images/LadyAventary_ElrovirRodiridan.webp",
            description = "A hand-drawn map of Veldekar with pink annotations for significant locations in the relationship between Lady Aventary and Elrovir Rodiridan.",
            width = 1_080,
            height = 801,
        )
    }
}
